const CityCommaCountry = (properties) => {
    if(properties.city && properties.country){
        return properties.city + ", " + properties.country;
    } else if(properties.city){
        return properties.city;
    } else if(properties.country){
        return properties.country;
    } else {
        return "";
    }
}

export default CityCommaCountry;